/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nodataavailable2Inputs */

const en_common_nodataavailable2 = /** @type {(inputs: Common_Nodataavailable2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available`)
};

/**
* | output |
* | --- |
* | "No data available" |
*
* @param {Common_Nodataavailable2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_nodataavailable2 = /** @type {((inputs?: Common_Nodataavailable2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nodataavailable2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_nodataavailable2(inputs)
});
export { common_nodataavailable2 as "common_noDataAvailable" }